import { getCookie, setCookie } from './cookie';

const LOGIN_MRO_COOKIE = 'login_mro_popup';

export function isAvailable() {
  return !getCookie(LOGIN_MRO_COOKIE);
}

export function invalidate() {
  /**
   * не передаем куке время экспаиреда и устанавливаем в true параметр сессионной куки,
   * так как эта реализация setCookie в случае, если параметр days не передан, устанавливает ключ expired
   * равным 0, что сбрасывает её.
   */
  setCookie(LOGIN_MRO_COOKIE, 'meow', undefined, true);
}
